"use client"

import { ContentNullWhere } from "../others/content_null"
import { useStoreSession } from "@/app/store/slices/session/hook"
import { useStoreAdmin } from "@/app/store/slices/collection/user/admin/hook"
import { useStoreOperator } from "@/app/store/slices/collection/user/operator/hook"
import { useEffect } from "react"
import { usePathname, useRouter } from "next/navigation"
import { useStorePrivilege } from "@/app/store/slices/collection/privilege/hook"
import { useStoreLive } from "@/app/store/slices/live/hook"
import { VisualiseurLoader } from "@/app/component"
import { AnimatePresence } from "framer-motion"
import { motion } from "framer-motion"
import { LogoSava } from "@/app/auth/signin/component"
import { Chip } from "@heroui/chip"

export function GlobalDataStoreInitializer() {
  const { isLoading, session, self } = useStoreSession(undefined, true)
  const pathname = usePathname()
  const router = useRouter()
  useStoreAdmin(true, true)
  useStoreOperator(true, true)
  useStoreLive(true)
  useStorePrivilege(true, true)

  useEffect(() => {
    if (self && session?.role === "operator") {
      if (!self.validated) router.push('/auth/attente')
    }
  }, [session, self, pathname])


  return (
    <ContentNullWhere
      where={["/auth/pass", "/", "/auth/signin", "/auth/attente", "/auth/forgotpassword"]}
    >
      <AnimatePresence>
        {session === null && isLoading.retrieve && (
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-950"
          >
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#E31D2B]/10 rounded-full blur-[120px]" />
            </div>

            <div className="relative flex flex-col items-center gap-8 text-center px-6">
              <motion.div
                animate={{
                  scale: [1, 1.05, 1],
                  opacity: [0.8, 1, 0.8]
                }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: "easeInOut"
                }}
                className="relative"
              >
                <div className="absolute -inset-8 bg-[#E31D2B]/20 rounded-full blur-3xl" />
                <LogoSava />
              </motion.div>

              <div className="flex flex-col items-center gap-4">
                <VisualiseurLoader />

                <div className="flex flex-col justify-center items-center gap-1">
                  <Chip
                    variant="flat"
                    className="bg-[#E31D2B]/10 text-[#E31D2B] border-none font-black uppercase tracking-[0.2em] text-[10px] h-6"
                  >
                    Initialisation du studio
                  </Chip>
                  <p className="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-widest animate-pulse">
                    Récupération de votre session...
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute bottom-12 text-center">
              <p className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-300 dark:text-slate-700">
                SAVA Radio • Sakaizan&apos;ny Vahoaka
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </ContentNullWhere>
  )
}